module.exports = __webpack_public_path__ + "img/zubehoer_t-stueck.3ec678f1.jpg";